import { queryOptions } from '@tanstack/react-query';

import type { PublicFileGallery } from '@mds/shared/types/file';

import * as galleryApi from './gallery.api';

/** Staff change a gallery by uploading to its folder, which is rare within a visit. */
const GALLERY_STALE_TIME = 5 * 60_000;

export const galleryKeys = {
  all: ['gallery'] as const,
  detail: (gallery: PublicFileGallery) => [...galleryKeys.all, gallery] as const,
};

export const galleryQueries = {
  detail: (gallery: PublicFileGallery) =>
    queryOptions({
      queryKey: galleryKeys.detail(gallery),
      queryFn: () => galleryApi.getGallery(gallery),
      staleTime: GALLERY_STALE_TIME,
    }),
};
